import React from 'react';
import { VscGame } from 'react-icons/vsc';
import { PlayfulCard, PlayfulCardButton } from '@/components/custom/playful-card';
import { AvatarWrapper } from '@/components/ui/avatar';
import avatar1 from '../../week-challenge/week-challenge-card-duel/images/img1.png';
import avatar2 from '../../week-challenge/week-challenge-card-duel/images/img2.png';
import avatar3 from '../../week-challenge/week-challenge-card-duel/images/img3.png';

export function DuelsPlayfulHighlightCard({ onClick }) {
  return (
    <PlayfulCard
      badge={{ text: 'Novidade', variant: 'rose-soft' }}
      className="p-5"
      onClick={onClick}
    >
      <div className="relative my-4 flex items-end justify-center -space-x-6">
        <AvatarWrapper
          src={avatar1}
          className="size-14"
        />
        <AvatarWrapper
          src={avatar2}
          className="size-20"
        />
        <AvatarWrapper
          src={avatar3}
          className="size-14"
        />
      </div>

      <h3 className="mb-0 text-center text-base font-extrabold text-neutral-900">Desafie seus colegas</h3>
      <p className="mb-0 mt-1 text-center text-sm text-neutral-dark">Participe de duelos e teste seus conhecimentos</p>

      <div className="mt-auto pt-4">
        <PlayfulCardButton
          icon={VscGame}
          variant="rose"
          onClick={onClick}
        >
          Iniciar Duelos
        </PlayfulCardButton>
      </div>
    </PlayfulCard>
  );
}
